// import React from 'react'
// import { NavLink } from 'react-router-dom'
// import { SlHome } from 'react-icons/sl'
// import { BsWallet, BsGift } from 'react-icons/bs'
// import { FiUser, FiUsers } from 'react-icons/fi'
// import { AiOutlineMessage } from 'react-icons/ai'
// import { BiMessageSquareDetail } from 'react-icons/bi'

// const BottonMenu = ({ w3_close }) => {
//   return (
//     <div className="bottom_nav_wrapper">
//       <div className="bottom_nav_bar">

//         <NavLink exact to="/wallet" className="nav_item" activeClassName="active">
//           <img src="/wallet.png" alt="" />
//         </NavLink>

//         <NavLink exact to="/refer" className="nav_item" activeClassName="active">
//           <img src="/bootom-refer.png" alt="" style={{marginRight:"60px"}} />
//         </NavLink>

//         {/* CENTER HOME BUTTON */}
//         <NavLink exact to="/landing" className="center_button" activeClassName="active_center">
//           <img src="/home.png" alt="" />
//         </NavLink>

//         <NavLink exact to="/support" className="nav_item" activeClassName="active">
//           <img src="/customer-support.png" alt="" />
//         </NavLink>

//         <NavLink exact to="/Profile" className="nav_item" activeClassName="active">
//           <img src="/bootom_user.png" alt="" />
//         </NavLink>

//       </div>
//     </div>

//   )
// }

// export default BottonMenu


import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
import { Wallet, Gift, Home, Headphones, User } from 'lucide-react';
// import './BottonMenu.css';

const BottonMenu = () => {
  const [clickedTab, setClickedTab] = useState(null);

  const handleTabClick = (tabName) => {
    setClickedTab(tabName);
    setTimeout(() => {
      setClickedTab(null);
    }, 600); // Reset animation state
  };

  return (
    <div className="bottom_nav_wrapper">
      <div className="bottom_nav_bar">
        
        {/* 1. WALLET TAB */}
        <NavLink
          exact
          to="/wallet"
          className={`nav_item ${clickedTab === 'wallet' ? 'animate_wallet' : ''}`}
          activeClassName="active"
          onClick={() => handleTabClick('wallet')}
        >
          <div className="nav_icon_wrapper">
            <Wallet className="lucide_icon" size={22} />
            <span className="active_pill"></span>
          </div>
          <span className="nav_label">Wallet</span>
        </NavLink>

        {/* 2. REFER TAB */}
        <NavLink
          exact
          to="/refer"
          className={`nav_item ${clickedTab === 'refer' ? 'animate_bounce' : ''}`}
          activeClassName="active"
          onClick={() => handleTabClick('refer')}
        >
          <div className="nav_icon_wrapper">
            <Gift className="lucide_icon" size={22} />
            <span className="active_pill"></span>
          </div>
          <span className="nav_label">Refer</span>
        </NavLink>

        {/* 3. CENTER HOME BUTTON */}
        <div className="center_fab_container">
          <NavLink
            exact
            to="/landing"
            className="center_fab_button"
            activeClassName="active_center"
            onClick={() => handleTabClick('home')}
          >
            <div className="fab_pulse_aura"></div>
            <Home className="center_icon" size={24} />
          </NavLink>
        </div>

        {/* 4. SUPPORT TAB */}
        <NavLink
          exact
          to="/support"
          className={`nav_item ${clickedTab === 'support' ? 'animate_bounce' : ''}`}
          activeClassName="active"
          onClick={() => handleTabClick('support')}
        >
          <div className="nav_icon_wrapper">
            <Headphones className="lucide_icon" size={22} />
            <span className="active_pill"></span>
          </div>
          <span className="nav_label">Support</span>
        </NavLink>

        {/* 5. PROFILE TAB */}
        <NavLink
          exact
          to="/Profile"
          className={`nav_item ${clickedTab === 'profile' ? 'animate_bounce' : ''}`}
          activeClassName="active"
          onClick={() => handleTabClick('profile')}
        >
          <div className="nav_icon_wrapper">
            <User className="lucide_icon" size={22} />
            <span className="active_pill"></span>
          </div>
          <span className="nav_label">Profile</span>
        </NavLink>

      </div>
    </div>
  );
};

export default BottonMenu;